import fetch from 'unfetch';
import { fetchScsHandler } from './fetchScsHandler';
import { Toast } from 'zarm';
import { fetchCodeHandler } from './fetchCodeHandler';

const fetcher = (...args) => {
  const [url, params = {}, showError = true] = args;
  const { method = 'POST', body = {}, ...others } = params;

  let appToken = null;

  if (process.env.NODE_ENV !== 'development') {
    // 生产环境
    appToken = localStorage.getItem('appToken');
  } else {
    // 开发环境
    appToken = localStorage.getItem('appToken');
  }

  return fetch(url, {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', appToken },
    method,
    body: JSON.stringify(body),
    ...others,
  })
    .then((response) => fetchCodeHandler(response, showError).json())
    .then((response) => fetchScsHandler(response, showError))
    .catch((error) => {
      console.log('fetch error:', error);
      if (!window.navigator.onLine) {
        Toast.show('请检查网络连接！');
        return { success: false, message: error.message };
      }
      if (!showError) return { success: false, message: error.message };
      throw error;
    });
};

export default fetcher;
